<script setup lang="ts">
definePage({
  name: 'remark',
  meta: {
    title: '备注自选',
    cache: true,
  },
})

const checked = ref()
</script>

<template>
  <FmPageLayout navbar back class="page">
    <template #navbar>
      <div>
        <div class="m-t-4px text-18px font-500">
          沪港通南向(HKDQB.SH)
        </div>
        <div class="m-t-4px text-11px line-height-11px">
          42000.00 0.00 0.00%
        </div>
      </div>
    </template>
    <template #navbar-end>
      <span class="m-l-16px text-18px color-[#fff]">保存</span>
    </template>
    <div class="flex items-center bg-[#fff] p-b-20px p-l-10px p-r-10px p-t-20px">
      <div class="w-40%">
        <div class="font-500">
          沪港通南向
        </div>
        <div>HKDQ.HK</div>
      </div>
      <div class="w-20%">
        42000.00
      </div>
      <div class="w-20%">
        0.00
      </div>
      <div class="w-20%">
        0.00%
      </div>
    </div>

    <div class="p-l-7px p-r-7px p-t-20px">
      <div class="text-15px font-500">
        备注名
      </div>
      <div class="m-b-10px m-t-10px h-39px flex flex-1 items-center overflow-hidden rounded-7px bg-[#FAF8F9] p-l-15px" style="border: 1px solid #eee;">
        <input type="text" class="h-32px flex-1 bg-[#FAF8F9]" placeholder="请输入备注名">
      </div>
      <van-checkbox v-model="checked" class="m-l-4px text-9px" shape="square" icon-size="12px">
        备注名代替标的名称在自选股、报价详情页展
      </van-checkbox>
      <div class="m-t-15px text-15px font-500">
        备注信息
      </div>
      <div class="m-b-10px m-t-10px flex flex-1 items-center overflow-hidden rounded-7px bg-[#FAF8F9] p-l-15px" style="border: 1px solid #eee;">
        <textarea rows="7" class="flex-1 bg-[#FAF8F9] line-height-39px" placeholder="请输入备注信息" />
      </div>
    </div>
  </FmPageLayout>
</template>
